<template>
  <div class="content">
    <div class="row mt-5">
      <div class="col-md-12">
        <h3>{{ $t("titlePages.statisticsMyGustave") }}</h3>
        <div class="card">
          <div class="card-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-xl-10 col-lg-12 col-12 order-xl-1 order-1">
                  <div class="row">
                    <base-input class="col-md-3 mb-2" label="Période">
                      <el-select
                        class="select-primary"
                        v-model="periodPreset"
                        placeholder="Période"
                        @change="onPeriodPresetChange"
                      >
                        <el-option
                          v-for="option in periodOptions"
                          :key="option.value"
                          class="select-primary"
                          :value="option.value"
                          :label="option.label"
                        ></el-option>
                      </el-select>
                    </base-input>
                    <base-input class="col-md-3 mb-2" :label="$t('table.columns.Startdate')">
                      <el-date-picker
                        v-model="StartDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="YYYY-MM-DD"
                        :disabled="periodPreset !== 'custom'"
                        @change="onCustomDateChange"
                      ></el-date-picker>
                    </base-input>
                    <base-input class="col-md-3 mb-2" :label="$t('table.columns.Enddate')">
                      <el-date-picker
                        v-model="EndnDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="YYYY-MM-DD"
                        :disabled="periodPreset !== 'custom'"
                        @change="onCustomDateChange"
                      ></el-date-picker>
                    </base-input>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-12 col-12 order-xl-2 order-3">
                  <div class="row">
                    <base-button
                      v-if="$apollo.queries.getStatisticsMyGustaveProducts.loading ||
                            $apollo.queries.getStatisticsMyGustaveAnimalsClients.loading ||
                            $apollo.queries.getStatisticsMyGustaveHealthClients.loading"
                      loading
                      class="btn btn-just-icon btn-default mt-4 d-block"
                    >{{ $t("buttons.BtnLoad").toUpperCase() }}...</base-button>
                    <button
                      v-else
                      class="btn btn-just-icon btn-default mt-4 d-block"
                      @click="search"
                    >{{ $t("buttons.BtnSearch").toUpperCase() }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card ListGlobalTable stat-gustave-product-perf">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
              <div>
                <h4 class="mb-0 product-perf-title">
                  <i class="tim-icons icon-chart-bar-32 mr-2"></i>
                  Performance par produit
                </h4>
              </div>
              <div class="d-flex align-items-center flex-wrap product-perf-header-right">
                <base-button
                  v-if="$fullscreen.support"
                  @click="toggle('.stat-gustave-product-perf')"
                  class="btn-link"
                  type="market"
                  size="sm"
                  icon
                >
                  <i :class="[fullscreen ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
                </base-button>
              </div>
            </div>

            <div>
              <el-table
                :data="GlobalTable"
                v-loading='$apollo.queries.getStatisticsMyGustaveProducts.loading'
                show-summary
                :summary-method="getSummaries"
                @sort-change="onGlobalRateSort"
              >
                <el-table-column
                  prop='product'
                  :label="$t('table.columns.Product')"
                  minWidth='150'
                  show-overflow-tooltip
                  sortable
                >
                </el-table-column>
                <el-table-column
                  prop='nb_cotation'
                  :label="$t('table.columns.numberOfQuotations')"
                  minWidth='205'
                  show-overflow-tooltip
                  sortable
                >
                  <template scope="scope">
                    <label class="extract-cell-link" @click="getExtract(scope.row.product, 'cotations')">
                      <i
                        v-if="isExtractLoading(scope.row.product, 'cotations')"
                        class="fas fa-spinner fa-spin"
                      ></i>
                      <u v-else>
                        {{ formatThounsends(scope.row.nb_cotation) }}
                      </u>
                    </label>
                  </template>
                </el-table-column>
                <el-table-column
                  label="MER"
                  prop="mer"
                  min-width="90"
                  show-overflow-tooltip
                  sortable
                >
                  <template scope="scope">
                    <label class="extract-cell-link" @click="getExtract(scope.row.product, 'mer')">
                      <i
                        v-if="isExtractLoading(scope.row.product, 'mer')"
                        class="fas fa-spinner fa-spin"
                      ></i>
                      <u v-else>
                        {{ formatThounsends(scope.row.mer) }}
                      </u>
                    </label>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('table.columns.MerRate')"
                  prop="taux_mer"
                  min-width="160"
                  show-overflow-tooltip
                  sortable="custom"
                >
                  <template scope="scope">
                    <rate-cell
                      :rate="scope.row.mer_status.rate"
                      :color="scope.row.mer_status.color"
                      :status="scope.row.mer_status.status"
                      :bar-width="scope.row.mer_status.barWidth"
                      tooltip="Nombre de mises en relation divisé par le nombre de cotations sur la période sélectionnée."
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('table.columns.nameOfLeadsSuiteAbandon')"
                  prop="nb_leads_abandonment"
                  min-width="220"
                  show-overflow-tooltip
                  sortable
                >
                  <template scope="scope">
                    {{ formatThounsends(scope.row.nb_leads_abandonment) }}
                  </template>
                </el-table-column>
                <el-table-column
                   label="Nophone"
                  prop="nb_leads_nophone"
                  min-width="120"
                  show-overflow-tooltip
                  sortable
                >
                  <template scope="scope">
                    {{ formatThounsends(scope.row.nb_leads_nophone )}}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Taux de nophone sur cotation"
                  prop="taux_nophone"
                  min-width="200"
                  show-overflow-tooltip
                  sortable="custom"
                >
                  <template scope="scope">
                    <rate-cell
                      :rate="scope.row.nophone_status.rate"
                      :color="scope.row.nophone_status.color"
                      :status="scope.row.nophone_status.status"
                      :bar-width="scope.row.nophone_status.barWidth"
                      tooltip="Nombre de cotations sans numéro de téléphone divisé par le nombre total de cotations sur la période sélectionnée."
                    />
                  </template>
                </el-table-column>
              </el-table>

              <div class="row mt-4 product-perf-legends">
                <div class="col-lg-6 col-md-12 mb-3">
                  <div class="product-perf-legend-card">
                    <div class="product-perf-legend-title">
                      <i class="tim-icons icon-chart-bar-32"></i>
                      <span>Légende – Taux de MER</span>
                    </div>
                    <div class="product-perf-legend-row">
                      <div class="product-perf-legend-item">
                        <span class="product-perf-dot dot-red"></span>
                        <div class="product-perf-legend-text">
                          <span class="product-perf-legend-range">&lt; 30 %</span>
                          <span class="product-perf-legend-label">Critique</span>
                        </div>
                      </div>
                      <div class="product-perf-legend-item">
                        <span class="product-perf-dot dot-green"></span>
                        <div class="product-perf-legend-text">
                          <span class="product-perf-legend-range">30 % – 40 %</span>
                          <span class="product-perf-legend-label">Bon</span>
                        </div>
                      </div>
                      <div class="product-perf-legend-item">
                        <span class="product-perf-dot dot-blue"></span>
                        <div class="product-perf-legend-text">
                          <span class="product-perf-legend-range">&gt; 40 %</span>
                          <span class="product-perf-legend-label">Excellent</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 mb-3">
                  <div class="product-perf-legend-card">
                    <div class="product-perf-legend-title">
                      <i class="fas fa-phone"></i>
                      <span>Légende – Taux de nophone sur cotation</span>
                    </div>
                    <div class="product-perf-legend-row">
                      <div class="product-perf-legend-item">
                        <span class="product-perf-dot dot-green"></span>
                        <div class="product-perf-legend-text">
                          <span class="product-perf-legend-range">&lt; 15 %</span>
                          <span class="product-perf-legend-label">Excellent</span>
                        </div>
                      </div>
                      <div class="product-perf-legend-item">
                        <span class="product-perf-dot dot-orange"></span>
                        <div class="product-perf-legend-text">
                          <span class="product-perf-legend-range">15 % – 18 %</span>
                          <span class="product-perf-legend-label">À surveiller</span>
                        </div>
                      </div>
                      <div class="product-perf-legend-item">
                        <span class="product-perf-dot dot-red"></span>
                        <div class="product-perf-legend-text">
                          <span class="product-perf-legend-range">&gt; 18 %</span>
                          <span class="product-perf-legend-label">Critique</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card ListAnimauxTable">
          <span slot="header" class="badge-pill badge-market tab-title" @click="toggle('.ListAnimauxTable')" style="text-transform: uppercase;font-weight: bold;">
            <i class="fas fa-paw icon-large"></i>
            {{ $t('labels.Animals') }}
            <base-button v-if="$fullscreen.support" style="float: right;" class="btn-link" size="sm" icon>
            <i :class="[fullscreen ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
            </base-button>
          </span>
          <div class="card-body">
            <el-table row-class-name="booking-table-rows" :data="AnimauxTable" v-loading='$apollo.queries.getStatisticsMyGustaveAnimalsClients.loading' show-summary :summary-method="getSummaries_Animaux">
              <el-table-column
                prop='name_client'
                label="Client"
                minWidth='200'
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <el-table-column
                :label="$t('table.columns.Product')"
                minWidth='90'
                show-overflow-tooltip
              >
                {{ $t('labels.Animals') }}
              </el-table-column>
              <el-table-column
                prop='product'
                label="Type"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                STANDARD
              </el-table-column>
              <el-table-column
                prop='prix_lead'
                :label="$t('table.columns.advertiserPrice')"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
              <template scope="scope">
                {{ scope.row.prix_lead + " €" }}
              </template>
              </el-table-column>
              <el-table-column
                prop='imp'
                :label="$t('table.columns.numberOfQuotations')"
                minWidth='205'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.imp) }}
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="MER"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taux_mer"
                :label="$t('table.columns.MerRate')"
                minWidth='160'
                show-overflow-tooltip
                :sort-method="CustomSort_tauxmer_sante"
                sortable
              >
                <template scope="scope">
                  <rate-cell
                    :rate="scope.row.mer_status.rate"
                    :color="scope.row.mer_status.color"
                    :status="scope.row.mer_status.status"
                    :bar-width="scope.row.mer_status.barWidth"
                    tooltip="Nombre de mises en relation divisé par le nombre de cotations sur la période sélectionnée."
                  />
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop='force'
                label="Total MER force"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.force) }}
                </template>
              </el-table-column> -->
              <el-table-column
                prop='mer_number'
                label="CA Net"
                minWidth='120'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number * scope.row.prix_lead, true, 2) + " €" }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="Forcage MER"
                minWidth='120'
              > -->
                <!-- <template scope="scope">
                  <div class="row" v-if="scope.row.id_client === '515'">
                    <base-input type="number" v-model="scope.row.force" class="col-4"></base-input>
                    <base-input type="number" v-model="scope.row.interval" class="col-4"></base-input>
                    <el-tooltip
                      content="Activer ou Désactiver"
                      effect="light"
                      :open-delay="300"
                      placement="top"
                    >
                      <base-checkbox :value="scope.row.status==1" @change.native="statusAnnimauxChange($event, scope.row)" class="mb-2 col-1"></base-checkbox>
                    </el-tooltip>
                    <el-tooltip
                      content="validé"
                      effect="light"
                      :open-delay="300"
                      placement="top"
                    >
                      <base-button
                        @click.native="ChangeForceAnimaux(scope.row)"
                        class="btn-link col-2"
                        type="success"
                        size="sm"
                        icon
                      >
                        <i class="tim-icons icon-check-2"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                </template> -->
              <!-- </el-table-column> -->
            </el-table>
          </div>
        </div>
        <div class="card ListSanteTable">
          <span slot="header" class="badge-pill badge-market tab-title" style="text-transform: uppercase;font-weight: bold;">
            <i class="fas fa-heartbeat icon-large"></i>
            {{ $t('labels.Health') }}
            <base-button v-if="$fullscreen.support" style="float: right;" @click="toggle('.ListSanteTable')" class="btn-link" size="sm" icon>
            <i :class="[fullscreen ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
            </base-button>
          </span>
          <div class="card-body">
            <el-table row-class-name="booking-table-rows" :data="SanteTable" v-loading='$apollo.queries.getStatisticsMyGustaveHealthClients.loading' show-summary :summary-method="getSummaries_Sante">
              <el-table-column
                prop='name_client'
                label="Client"
                minWidth='200'
                show-overflow-tooltip
                sortable
                :sort-method="CustomSort_nameClient"
              >
              </el-table-column>
              <el-table-column
                :label="$t('table.columns.Product')"
                minWidth='90'
                show-overflow-tooltip
              >
                {{ $t('labels.Health') }}
              </el-table-column>
              <el-table-column
                prop='type'
                label="Type"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <el-table-column
                prop='prix_lead'
                :label="$t('table.columns.advertiserPrice')"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ scope.row.prix_lead +  " €"}}
                </template>
              </el-table-column>
              <el-table-column
                prop='imp'
                :label="$t('table.columns.numberOfQuotations')"
                minWidth='205'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.imp) }}
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="MER"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taux_mer"
                :label="$t('table.columns.MerRate')"
                minWidth='160'
                show-overflow-tooltip
                :sort-method="CustomSort_tauxmer_sante"
                sortable
              >
                <template scope="scope">
                  <rate-cell
                    :rate="scope.row.mer_status.rate"
                    :color="scope.row.mer_status.color"
                    :status="scope.row.mer_status.status"
                    :bar-width="scope.row.mer_status.barWidth"
                    tooltip="Nombre de mises en relation divisé par le nombre de cotations sur la période sélectionnée."
                  />
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop='force'
                label="Total MER force"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer) }}
                </template>
              </el-table-column> -->
              <el-table-column
                prop='ca'
                label="CA Net"
                minWidth='120'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.ca, true, 2) + " €" }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="Forcage MER"
                minWidth='120'
              > -->
              <!-- minWidth='380' -->
                <!-- <template scope="scope">
                  <div class="row" v-if="scope.row.id_client === '12868' || scope.row.id_client === '517' || scope.row.id_client === '76' || scope.row.id_client === '190' || scope.row.id_client === '654'">
                    <base-input type="number" v-model="scope.row.force" class="col-4"></base-input>
                    <base-input type="number" v-model="scope.row.interval" class="col-4"></base-input>
                    <el-tooltip
                      content="Activer ou Désactiver"
                      effect="light"
                      :open-delay="300"
                      placement="top"
                    >
                      <base-checkbox :value="scope.row.status==1" @change.native="statusSanteChange($event, scope.row)" class="mb-2 col-1"></base-checkbox>
                    </el-tooltip>
                    <el-tooltip
                      content="validé"
                      effect="light"
                      :open-delay="300"
                      placement="top"
                    >
                      <base-button
                        @click.native="ChangeForceSante(scope.row)"
                        class="btn-link col-2"
                        type="success"
                        size="sm"
                        icon
                      >
                        <i class="tim-icons icon-check-2"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                </template> -->
              <!-- </el-table-column> -->
            </el-table>
          </div>
        </div>
        <div class="card ListMrhTable">
          <span slot="header" class="badge-pill badge-market tab-title" style="text-transform: uppercase;font-weight: bold;">
            <i class="fas fa-home icon-large"></i>
            HABITATION
            <base-button v-if="$fullscreen.support" style="float: right;" @click="toggle('.ListMrhTable')" class="btn-link" size="sm" icon>
            <i :class="[fullscreen ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
            </base-button>
          </span>
          <div class="card-body">
            <el-table row-class-name="booking-table-rows" :data="MrhTable" v-loading='$apollo.queries.getStatisticsMyGustaveMRH.loading' show-summary :summary-method="getSummaries_Animaux">
              <el-table-column
                prop='name_client'
                label="Client"
                minWidth='200'
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <el-table-column
                :label="$t('table.columns.Product')"
                minWidth='90'
                show-overflow-tooltip
              >
                HABITATION
              </el-table-column>
              <el-table-column
                prop='product'
                label="Type"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                STANDARD
              </el-table-column>
              <el-table-column
                prop='prix_lead'
                :label="$t('table.columns.advertiserPrice')"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
              <template scope="scope">
                {{ scope.row.prix_lead + " €" }}
              </template>
              </el-table-column>
              <el-table-column
                prop='imp'
                :label="$t('table.columns.numberOfQuotations')"
                minWidth='205'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.imp) }}
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="MER"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taux_mer"
                :label="$t('table.columns.MerRate')"
                minWidth='160'
                show-overflow-tooltip
                :sort-method="CustomSort_tauxmer_sante"
                sortable
              >
                <template scope="scope">
                  <rate-cell
                    :rate="scope.row.mer_status.rate"
                    :color="scope.row.mer_status.color"
                    :status="scope.row.mer_status.status"
                    :bar-width="scope.row.mer_status.barWidth"
                    tooltip="Nombre de mises en relation divisé par le nombre de cotations sur la période sélectionnée."
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="CA Net"
                minWidth='120'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number * scope.row.prix_lead, true, 2) + " €" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="card ListAutoTable">
          <span slot="header" class="badge-pill badge-market tab-title" style="text-transform: uppercase;font-weight: bold;">
            <i class="fas fa-car icon-large"></i>
            AUTO
            <base-button v-if="$fullscreen.support" style="float: right;" @click="toggle('.ListAutoTable')" class="btn-link" size="sm" icon>
            <i :class="[fullscreen ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
            </base-button>
          </span>
          <div class="card-body">
            <el-table row-class-name="booking-table-rows" :data="AutoTable" v-loading='$apollo.queries.getStatisticsMyGustaveAUTO.loading' show-summary :summary-method="getSummaries_Animaux">
              <el-table-column
                prop='name_client'
                label="Client"
                minWidth='200'
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <el-table-column
                :label="$t('table.columns.Product')"
                minWidth='90'
                show-overflow-tooltip
              >
                AUTO
              </el-table-column>
              <el-table-column
                prop='product'
                label="Type"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                STANDARD
              </el-table-column>
              <el-table-column
                prop='prix_lead'
                :label="$t('table.columns.advertiserPrice')"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
              <template scope="scope">
                {{ scope.row.prix_lead + " €" }}
              </template>
              </el-table-column>
              <el-table-column
                prop='imp'
                :label="$t('table.columns.numberOfQuotations')"
                minWidth='205'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.imp) }}
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="MER"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taux_mer"
                :label="$t('table.columns.MerRate')"
                minWidth='160'
                show-overflow-tooltip
                :sort-method="CustomSort_tauxmer_sante"
                sortable
              >
                <template scope="scope">
                  <rate-cell
                    :rate="scope.row.mer_status.rate"
                    :color="scope.row.mer_status.color"
                    :status="scope.row.mer_status.status"
                    :bar-width="scope.row.mer_status.barWidth"
                    tooltip="Nombre de mises en relation divisé par le nombre de cotations sur la période sélectionnée."
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="CA Net"
                minWidth='120'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number * scope.row.prix_lead, true, 2) + " €" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="card ListEmprunteurTable">
          <span slot="header" class="badge-pill badge-market tab-title" style="text-transform: uppercase;font-weight: bold;">
            <i class="tim-icons icon-bank icon-large"></i>
            EMPRUNTEUR
            <base-button v-if="$fullscreen.support" style="float: right;" @click="toggle('.ListEmprunteurTable')" class="btn-link" size="sm" icon>
            <i :class="[fullscreen ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
            </base-button>
          </span>
          <div class="card-body">
            <el-table row-class-name="booking-table-rows" :data="EmprunteurTable" v-loading='$apollo.queries.getStatisticsMyGustaveEmprunteur.loading' show-summary :summary-method="getSummaries_Animaux">
              <el-table-column
                prop='name_client'
                label="Client"
                minWidth='200'
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <el-table-column
                :label="$t('table.columns.Product')"
                minWidth='90'
                show-overflow-tooltip
              >
                EMPRUNTEUR
              </el-table-column>
              <el-table-column
                prop='product'
                label="Type"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                STANDARD
              </el-table-column>
              <el-table-column
                prop='prix_lead'
                :label="$t('table.columns.advertiserPrice')"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
              <template scope="scope">
                {{ scope.row.prix_lead + " €" }}
              </template>
              </el-table-column>
              <el-table-column
                prop='imp'
                :label="$t('table.columns.numberOfQuotations')"
                minWidth='205'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.imp) }}
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="MER"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taux_mer"
                :label="$t('table.columns.MerRate')"
                minWidth='160'
                show-overflow-tooltip
                :sort-method="CustomSort_tauxmer_sante"
                sortable
              >
                <template scope="scope">
                  <rate-cell
                    :rate="scope.row.mer_status.rate"
                    :color="scope.row.mer_status.color"
                    :status="scope.row.mer_status.status"
                    :bar-width="scope.row.mer_status.barWidth"
                    tooltip="Nombre de mises en relation divisé par le nombre de cotations sur la période sélectionnée."
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="CA Net"
                minWidth='120'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number * scope.row.prix_lead, true, 2) + " €" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="card ListCreditConsoTable">
          <span slot="header" class="badge-pill badge-market tab-title" style="text-transform: uppercase;font-weight: bold;">
            <i class="fas fa-credit-card"></i>
            CRÉDIT CONSO
            <base-button v-if="$fullscreen.support" style="float: right;" @click="toggle('.ListCreditConsoTable')" class="btn-link" size="sm" icon>
            <i :class="[fullscreen ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
            </base-button>
          </span>
          <div class="card-body">
            <el-table row-class-name="booking-table-rows" :data="CreditConsoTable" v-loading='$apollo.queries.getStatisticsMyGustaveCreditConso.loading' show-summary :summary-method="getSummaries_Animaux">
              <el-table-column
                prop='name_client'
                label="Client"
                minWidth='200'
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <el-table-column
                :label="$t('table.columns.Product')"
                minWidth='90'
                show-overflow-tooltip
              >
                CRÉDIT CONSO
              </el-table-column>
              <el-table-column
                prop='product'
                label="Type"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                STANDARD
              </el-table-column>
              <el-table-column
                prop='prix_lead'
                :label="$t('table.columns.advertiserPrice')"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
              <template scope="scope">
                {{ scope.row.prix_lead + " €" }}
              </template>
              </el-table-column>
              <el-table-column
                prop='imp'
                :label="$t('table.columns.numberOfQuotations')"
                minWidth='205'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.imp) }}
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="MER"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taux_mer"
                :label="$t('table.columns.MerRate')"
                minWidth='160'
                show-overflow-tooltip
                :sort-method="CustomSort_tauxmer_sante"
                sortable
              >
                <template scope="scope">
                  <rate-cell
                    :rate="scope.row.mer_status.rate"
                    :color="scope.row.mer_status.color"
                    :status="scope.row.mer_status.status"
                    :bar-width="scope.row.mer_status.barWidth"
                    tooltip="Nombre de mises en relation divisé par le nombre de cotations sur la période sélectionnée."
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="CA Net"
                minWidth='120'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number * scope.row.prix_lead, true, 2) + " €" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="card ListPerTable">
          <span slot="header" class="badge-pill badge-market tab-title" style="text-transform: uppercase;font-weight: bold;">
            <i class="fa-solid fa-coins"></i>
            ASSURANCE VIE
            <base-button v-if="$fullscreen.support" style="float: right;" @click="toggle('.ListPerTable')" class="btn-link" size="sm" icon>
            <i :class="[fullscreen ? 'fas fa-compress icon-large' : 'fas fa-expand icon-large']"></i>
            </base-button>
          </span>
          <div class="card-body">
            <el-table row-class-name="booking-table-rows" :data="PerTable" v-loading='$apollo.queries.getStatisticsMyGustavePer.loading' show-summary :summary-method="getSummaries_Animaux">
              <el-table-column
                prop='name_client'
                label="Client"
                minWidth='200'
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <el-table-column
                :label="$t('table.columns.Product')"
                minWidth='90'
                show-overflow-tooltip
              >
                ASSURANCE VIE
              </el-table-column>
              <el-table-column
                prop='product'
                label="Type"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                STANDARD
              </el-table-column>
              <el-table-column
                prop='prix_lead'
                :label="$t('table.columns.advertiserPrice')"
                minWidth='170'
                show-overflow-tooltip
                sortable
              >
              <template scope="scope">
                {{ scope.row.prix_lead + " €" }}
              </template>
              </el-table-column>
              <el-table-column
                prop='imp'
                :label="$t('table.columns.numberOfQuotations')"
                minWidth='205'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.imp) }}
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="MER"
                minWidth='100'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taux_mer"
                :label="$t('table.columns.MerRate')"
                minWidth='160'
                show-overflow-tooltip
                :sort-method="CustomSort_tauxmer_sante"
                sortable
              >
                <template scope="scope">
                  <rate-cell
                    :rate="scope.row.mer_status.rate"
                    :color="scope.row.mer_status.color"
                    :status="scope.row.mer_status.status"
                    :bar-width="scope.row.mer_status.barWidth"
                    tooltip="Nombre de mises en relation divisé par le nombre de cotations sur la période sélectionnée."
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop='mer_number'
                label="CA Net"
                minWidth='120'
                show-overflow-tooltip
                sortable
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.mer_number * scope.row.prix_lead, true, 2) + " €" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import {Select, Option ,DatePicker} from 'element-ui'
  import { Table, TableColumn } from 'element-ui';
  import { BaseCheckbox } from 'src/components';
  import gql from 'graphql-tag'
  import PerfectScrollbar from 'perfect-scrollbar';
  import RateCell from './RateCell.vue'
  import {
    mapProductRow,
    calculateTotals,
    calculateRate,
    formatRate,
    resolvePeriodDates,
    sortRateNullLast,
    getMerStatus,
    getNoPhoneStatus,
    getColorHex,
    buildRateModel
  } from './productPerformance'

  export default {
    apollo: {
      getStatisticsMyGustaveProducts: {
        client: 'MARKET',
        query: gql `
          query ($date_debut: String!, $date_fin: String!) {
            getStatisticsMyGustaveProducts(date_debut: $date_debut, date_fin: $date_fin) {
              affichage_sante
              affichage_animaux
              mer_sante
              mer_animaux
              ab_sante
              ab_animaux
              affichage_mrh
              mer_mrh
              ab_mrh
              affichage_auto
              mer_auto
              ab_auto
              affichage_emprunteur
              mer_emprunteur
              ab_emprunteur
              affichage_creditconso
              ab_creditconso
              mer_creditconso
              affichage_per
              ab_per
              mer_per
                nophone_ab_sante
    nophone_ab_animaux
    nophone_ab_mrh
    nophone_ab_auto
    nophone_ab_emprunteur
    nophone_ab_creditconso
            }
          }
        `,
        variables () {
          return {
            id_utilisateur: JSON.parse(localStorage.getItem('utilisateur')).id,
            date_debut: this.StartDate,
            date_fin: this.EndnDate
          }
        },
        skip() {
          return this.SkipQuery_Global
        },
        result({ data, loader, networkStatus }) {
          const stats = data.getStatisticsMyGustaveProducts
          this.GlobalTable = [
            mapProductRow({
              name: 'ASSURANCE ANIMAUX',
              quotations: stats.affichage_animaux,
              mer: stats.mer_animaux,
              abandons: stats.ab_animaux,
              noPhone: stats.nophone_ab_animaux
            }),
            mapProductRow({
              name: 'ASSURANCE AUTO',
              quotations: stats.affichage_auto,
              mer: stats.mer_auto,
              abandons: stats.ab_auto,
              noPhone: stats.nophone_ab_auto
            }),
            mapProductRow({
              name: 'ASSURANCE EMPRUNTEUR',
              quotations: stats.affichage_emprunteur,
              mer: stats.mer_emprunteur,
              abandons: stats.ab_emprunteur,
              noPhone: stats.nophone_ab_emprunteur
            }),
            mapProductRow({
              name: 'ASSURANCE HABITATION',
              quotations: stats.affichage_mrh,
              mer: stats.mer_mrh,
              abandons: stats.ab_mrh,
              noPhone: stats.nophone_ab_mrh
            }),
            mapProductRow({
              name: 'ASSURANCE SANTÉ',
              quotations: stats.affichage_sante,
              mer: stats.mer_sante,
              abandons: stats.ab_sante,
              noPhone: stats.nophone_ab_sante
            }),
            mapProductRow({
              name: 'CRÉDIT CONSO',
              quotations: stats.affichage_creditconso,
              mer: stats.mer_creditconso,
              abandons: stats.ab_creditconso,
              noPhone: stats.nophone_ab_creditconso
            }),
            mapProductRow({
              name: 'ASSURANCE VIE',
              quotations: stats.affichage_per,
              mer: stats.mer_per,
              abandons: stats.ab_per,
              noPhone: 0
            })
          ]
          this.SkipQuery_Global = true
        },
        fetchPolicy: 'network-only',
        update: data => data.getStatisticsMyGustaveProducts,
      },
      getStatisticsMyGustaveAnimalsClients: {
        client: 'MARKET',
        query: gql `
          query ($date_debut: String!, $date_fin: String!) {
            getStatisticsMyGustaveAnimalsClients(date_debut: $date_debut, date_fin: $date_fin) {
              id_client
              name_client
              mer_number
              imp
              prix_lead
              produit
              interval
              status
              status_client
            }
          }
        `,
        variables () {
          return {
            date_debut: this.StartDate,
            date_fin: this.EndnDate
          }
        },
        skip() {
          return this.SkipQuery_Animaux
        },
        result({ data, loader, networkStatus }) {
          this.AnimauxTable = this.enrichClientMerRows(
            data.getStatisticsMyGustaveAnimalsClients.filter(item => { return item.imp != 0 })
          )
          this.SkipQuery_Animaux = true
        },
        fetchPolicy: 'network-only',
      },
      getStatisticsMyGustaveMRH: {
        client: 'MARKET',
        query: gql `
          query ($date_debut: String!, $date_fin: String!) {
            getStatisticsMyGustaveMRH(date_debut: $date_debut, date_fin: $date_fin) {
              force
              id_client
              imp
              interval
              mer_number
              name_client
              prix_lead
              produit
              status
              status_client
            }
          }
        `,
        variables () {
          return {
            date_debut: this.StartDate,
            date_fin: this.EndnDate
          }
        },
        skip() {
          return this.SkipQuery_Mrh
        },
        result({ data, loader, networkStatus }) {
          this.MrhTable = this.enrichClientMerRows(
            data.getStatisticsMyGustaveMRH.filter(item => { return item.imp != 0 })
          )
          // this.MrhTable = data.getStatisticsMyGustaveMRH
          this.SkipQuery_Mrh = true
        },
        fetchPolicy: 'network-only',
      },
      getStatisticsMyGustaveAUTO: {
        client: 'MARKET',
        query: gql `
          query ($date_debut: String!, $date_fin: String!) {
            getStatisticsMyGustaveAUTO(date_debut: $date_debut, date_fin: $date_fin) {
              force
              id_client
              imp
              interval
              mer_number
              name_client
              prix_lead
              produit
              status
              status_client
            }
          }
        `,
        variables () {
          return {
            date_debut: this.StartDate,
            date_fin: this.EndnDate
          }
        },
        skip() {
          return this.SkipQuery_Auto
        },
        result({ data, loader, networkStatus }) {
          this.AutoTable = this.enrichClientMerRows(
            data.getStatisticsMyGustaveAUTO.filter(item => { return item.imp != 0 })
          )
          this.SkipQuery_Auto = true
        },
        fetchPolicy: 'network-only',
      },
      getStatisticsMyGustaveEmprunteur: {
        client: 'MARKET',
        query: gql `
          query ($date_debut: String!, $date_fin: String!) {
            getStatisticsMyGustaveEmprunteur(date_debut: $date_debut, date_fin: $date_fin) {
              force
              id_client
              imp
              interval
              mer_number
              name_client
              prix_lead
              produit
              status
              status_client
            }
          }
        `,
        variables () {
          return {
            date_debut: this.StartDate,
            date_fin: this.EndnDate
          }
        },
        skip() {
          return this.SkipQuery_Emprunteur
        },
        result({ data, loader, networkStatus }) {
          this.EmprunteurTable = this.enrichClientMerRows(
            data.getStatisticsMyGustaveEmprunteur.filter(item => { return item.imp != 0 || item.mer_number != 0  })
          )
          this.SkipQuery_Emprunteur = true
        },
        fetchPolicy: 'network-only',
      },
      getStatisticsMyGustaveCreditConso: {
        client: 'MARKET',
        query: gql `
          query ($date_debut: String!, $date_fin: String!) {
            getStatisticsMyGustaveCreditConso(date_debut: $date_debut, date_fin: $date_fin) {
              force
              id_client
              imp
              interval
              mer_number
              name_client
              prix_lead
              produit
              status
              status_client
            }
          }
        `,
        variables () {
          return {
            date_debut: this.StartDate,
            date_fin: this.EndnDate
          }
        },
        skip() {
          return this.SkipQuery_CreditConso
        },
        result({ data, loader, networkStatus }) {
          this.CreditConsoTable = this.enrichClientMerRows(
            data.getStatisticsMyGustaveCreditConso.filter(item => { return item.imp != 0 || item.mer_number != 0  })
          )
          this.SkipQuery_CreditConso = true
        },
        fetchPolicy: 'network-only',
      },
      getStatisticsMyGustavePer: {
        client: 'MARKET',
        query: gql `
          query ($date_debut: String!, $date_fin: String!) {
            getStatisticsMyGustavePer(date_debut: $date_debut, date_fin: $date_fin) {
              force
              id_client
              imp
              interval
              mer_number
              name_client
              prix_lead
              produit
              status
              status_client
            }
          }
        `,
        variables () {
          return {
            date_debut: this.StartDate,
            date_fin: this.EndnDate
          }
        },
        skip() {
          return this.SkipQuery_Per
        },
        result({ data, loader, networkStatus }) {
          this.PerTable = this.enrichClientMerRows(
            data.getStatisticsMyGustavePer.filter(item => { return item.imp != 0 || item.mer_number != 0  })
          )
          this.SkipQuery_Per = true
        },
        fetchPolicy: 'network-only',
      },
      getStatisticsMyGustaveHealthClients: {
        client: 'MARKET',
        query: gql `
          query ($date_debut: String!, $date_fin: String!) {
            getStatisticsMyGustaveHealthClients(date_debut: $date_debut, date_fin: $date_fin) {
              name_client
              type
              prix_lead
              imp
              mer_number
              id_client
              status_client
            }
          }
        `,
        variables () {
          return {
            date_debut: this.StartDate,
            date_fin: this.EndnDate
          }
        },
        skip() {
          return this.SkipQuery_Sante
        },
        result({ data, loader, networkStatus }) {
          this.SanteTable = data.getStatisticsMyGustaveHealthClients.filter(item => { return item.imp != 0 })
          let rmindex = -1;
          this.SanteTable.forEach((element,index) => {
            // if (element.id_client == '14' && element.type == 'salaries') {
            //   let find = this.SanteTable.find(x => x.type == 'seniors' && x.id_client == '14')
            //   if (find) {
            //     find.ca = element.mer_number * find.prix_lead + find.mer_number * find.prix_lead
            //     find.mer_number = element.mer_number + find.mer_number
            //     find.imp = element.imp + find.imp
            //   }
            //   rmindex = index
            // }
            // else {
              element.ca = element.mer_number * element.prix_lead
            // }
          });
          if (rmindex != -1) {
            this.SanteTable.splice(rmindex, 1);
          }
          this.SanteTable = this.enrichClientMerRows(this.SanteTable)
          this.SkipQuery_Sante = true
        },
        fetchPolicy: 'network-only',
      }
    },
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker,
      BaseCheckbox,
      RateCell
    },
    data() {
      return {
        fullscreen: false,
        PerfectScrollbar: null,
        StartDate: null,
        EndnDate: null,
        searchQuery: '',
        periodPreset: 'today',
        periodOptions: [
          { value: 'today', label: "Aujourd'hui" },
          { value: 'yesterday', label: 'Hier' },
          { value: 'last7', label: '7 derniers jours' },
          { value: 'month', label: 'Mois en cours' },
          { value: 'custom', label: 'Période personnalisée' }
        ],
        GlobalTable: [],
        AnimauxTable: [],
        MrhTable: [],
        AutoTable: [],
        EmprunteurTable: [],
        CreditConsoTable: [],
        PerTable: [],
        SanteTable: [],
        SkipQuery_Global: true,
        SkipQuery_Sante: true,
        SkipQuery_Animaux: true,
        SkipQuery_Mrh: true,
        SkipQuery_Auto: true,
        SkipQuery_Emprunteur: true,
        SkipQuery_CreditConso: true,
        SkipQuery_Per: true,
        extractLoadingKey: null,
      }
    },
    created() {
      this.applyPeriodPreset('today')
    },
    methods: {
      applyPeriodPreset(preset) {
        if (preset === 'custom') {
          return
        }
        const range = resolvePeriodDates(preset, new Date())
        this.StartDate = range.start
        this.EndnDate = range.end
      },
      onPeriodPresetChange(preset) {
        this.applyPeriodPreset(preset)
        if (preset !== 'custom') {
          this.search()
        }
      },
      onCustomDateChange() {
        this.periodPreset = 'custom'
      },
      enrichClientMerRows(rows) {
        return (rows || []).map(row => {
          const merStatus = buildRateModel(row.mer_number, row.imp, 'mer')
          return {
            ...row,
            taux_mer: merStatus.rate,
            mer_status: merStatus
          }
        })
      },
      onGlobalRateSort({ prop, order }) {
        if (prop !== 'taux_mer' && prop !== 'taux_nophone') {
          return
        }
        if (!order) {
          return
        }
        const sorted = this.GlobalTable.slice().sort((a, b) =>
          sortRateNullLast(a, b, prop, order)
        )
        this.GlobalTable = sorted
      },
      renderSummaryRate(h, rate, quotations, type) {
        const status = type === 'noPhone'
          ? getNoPhoneStatus(rate, quotations)
          : getMerStatus(rate, quotations)
        const color = getColorHex(status.color)
        const label = formatRate(rate)
        const width = rate === null ? 0 : Math.min(100, Math.max(0, rate))
        return h('div', { class: 'rate-cell rate-cell--summary' }, [
          h('span', { style: { color, fontWeight: '600', fontSize: '0.85rem' } }, label),
          h('div', {
            style: {
              width: '100%',
              height: '4px',
              borderRadius: '4px',
              background: 'rgba(139, 149, 167, 0.25)',
              marginTop: '4px',
              overflow: 'hidden'
            }
          }, [
            h('div', {
              style: {
                width: width + '%',
                height: '100%',
                borderRadius: '4px',
                background: color
              }
            })
          ])
        ])
      },
      toggle (div) {
        this.$fullscreen.toggle(this.$el.querySelector(div), {
          wrap: false,
          callback: this.fullscreenChange
        })
      },
      fullscreenChange (fullscreen) {
        this.fullscreen = fullscreen
        if (fullscreen) {
          this.PerfectScrollbar = new PerfectScrollbar(".ListSanteTable");
        }
        else {
          this.PerfectScrollbar.destroy();
          this.PerfectScrollbar = null
        }
      },
      CustomSort_nameClient(a, b) {
        return a.name_client.localeCompare(b.name_client);
      },
      search() {
        this.SkipQuery_Global = false
        this.SkipQuery_Sante = false
        this.SkipQuery_Animaux = false
        this.SkipQuery_Mrh = false
        this.SkipQuery_Auto = false
        this.SkipQuery_Emprunteur = false
        this.SkipQuery_CreditConso = false
        this.SkipQuery_Per = false
      },
      statusAnnimauxChange(event, row) {
        if (row.status == 0) {
          row.status = 1
        } else if (row.status == 1) {
          row.status = 0
        }
      },
      statusSanteChange(event, row) {
        if (row.status == 0) {
          row.status = 1
        } else if (row.status == 1) {
          row.status = 0
        }
      },
      getSummaries(param) {
        const { columns, data } = param;
        const totals = calculateTotals(data)
        const sums = [];
        columns.forEach((column) => {
          const prop = column.property
          if (prop === 'product') {
            sums.push('Total')
          } else if (prop === 'nb_cotation') {
            sums.push(this.formatThounsends(totals.quotations))
          } else if (prop === 'mer') {
            sums.push(this.formatThounsends(totals.mer))
          } else if (prop === 'taux_mer') {
            sums.push(this.renderSummaryRate(this.$createElement, totals.merRate, totals.quotations, 'mer'))
          } else if (prop === 'nb_leads_abandonment') {
            sums.push(this.formatThounsends(totals.abandons))
          } else if (prop === 'nb_leads_nophone') {
            sums.push(this.formatThounsends(totals.noPhone))
          } else if (prop === 'taux_nophone') {
            sums.push(this.renderSummaryRate(this.$createElement, totals.noPhoneRate, totals.quotations, 'noPhone'))
          } else {
            sums.push('')
          }
        });
        return sums;
      },
      getSummaries_Animaux(param) {
        const { columns, data } = param;
        let somme_prix_lead = 0
        let somme_imp = 0
        let somme_mer = 0
        let somme_ca = 0
        data.forEach(stats => {
          somme_prix_lead += stats.prix_lead
          somme_imp += stats.imp
          somme_mer += stats.mer_number
          // somme_force += stats.force
          somme_ca += stats.mer_number * stats.prix_lead
        });
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "";
            return;
          } else if (index === 3) {
            sums[index] = somme_prix_lead + " €";
            return;
          } else if (index === 4) {
            sums[index] = this.formatThounsends(somme_imp);
            return;
          } else if (index === 5) {
            sums[index] = this.formatThounsends(somme_mer);
            return;
          } else if (index === 6) {
            sums[index] = this.renderSummaryRate(
              this.$createElement,
              calculateRate(somme_mer, somme_imp),
              somme_imp,
              'mer'
            );
            return;
          } else if (index === 7) {
            sums[index] = this.formatThounsends(somme_ca, true, 2) +" €";
            return;
          } else {
            sums[index] = "";
            return;
          }
        });
        return sums;
      },
      getSummaries_Sante(param) {
        const { columns, data } = param;
        let somme_prix_lead = 0
        let somme_imp = 0
        let somme_mer = 0
        // let somme_force = 0
        let somme_ca = 0
        data.forEach(stats => {
          somme_prix_lead += stats.prix_lead
          somme_imp += stats.imp
          somme_mer += stats.mer_number
          // somme_force += stats.force
          somme_ca += stats.ca
        });
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "";
            return;
          } else if (index === 3) {
            sums[index] = somme_prix_lead + " €";
            return;
          } else if (index === 4) {
            sums[index] = this.formatThounsends(somme_imp);
            return;
          } else if (index === 5) {
            sums[index] = this.formatThounsends(somme_mer);
            return;
          } else if (index === 6) {
            sums[index] = this.renderSummaryRate(
              this.$createElement,
              calculateRate(somme_mer, somme_imp),
              somme_imp,
              'mer'
            );
            return;
          } else if (index === 7) {
            sums[index] = this.formatThounsends(somme_ca, true, 2) + " €";
            return;
          } else {
            sums[index] = "";
            return;
          }
        });
        return sums;
      },
      isExtractLoading(product, type) {
        return this.extractLoadingKey === product + '|' + type
      },
      getExtract(product, type) {
        const extracts = {
          'ASSURANCE ANIMAUX': { endpoint: 'telecharge_stat', produit: 2, label: 'ANIMAUX' },
          'ASSURANCE SANTÉ': { endpoint: 'telecharge_stat', produit: 1, label: 'SANTE' },
          'ASSURANCE HABITATION': { endpoint: 'telecharge_stat_mrh', label: 'MRH' },
          'ASSURANCE AUTO': { endpoint: 'telecharge_stat_auto', label: 'AUTO' },
          'ASSURANCE EMPRUNTEUR': { endpoint: 'telecharge_stat_emprunteur', label: 'EMPRUNTEUR' },
          'CRÉDIT CONSO': { endpoint: 'telecharge_stat_creditconso', label: 'CREDITCONSO' },
          'ASSURANCE VIE': { endpoint: 'telecharge_stat_per', label: 'PER' },
        }
        const extract = extracts[product]
        if (!extract || (type !== 'mer' && type !== 'cotations') || this.extractLoadingKey) {
          return
        }

        this.extractLoadingKey = product + '|' + type
        const token = localStorage.getItem('token_jwt')
        const formData = new FormData()
        formData.append('date_debut', this.StartDate)
        formData.append('date_fin', this.EndnDate)
        formData.append('endpoint', extract.endpoint)
        formData.append('option', type === 'mer' ? 2 : 1)
        if (extract.produit) {
          formData.append('produit', extract.produit)
        }

        this.axios
          .post('https://apileadmarket.wee-do-it.net/api/telecharge-stat-gustave', formData, {
            headers: {
              authorization: `Bearer ${token}`
            },
            responseType: 'blob'
          })
          .then(response => {
            const kind = type === 'mer' ? 'MER' : 'COTATIONS'
            const filename = `STATISTIQUES_MON_GUSTAVE_${extract.label}_${kind} - DD ${this.StartDate} - DF ${this.EndnDate}.csv`
            const fileURL = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = fileURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(fileURL)
           this.sendNotif('STATISTIQUES MON GUSTAVE :' + type)
          })
          .catch(error => {
            console.error("Erreur lors de l'extract:", error)
          })
          .then(() => {
            this.extractLoadingKey = null
          })
      },
      sendNotif(titre) {
        const urlApi = "https://apileadmarket.wee-do-it.net";
        const formData = new FormData();
        const token = localStorage.getItem("token_jwt")
        formData.append('interface', titre)

        this.axios
            .post(`${urlApi}/api/send-notif-data`, formData, {
            headers: {
                    'authorization': `Bearer ${token}`
                    }
            })
            .then(response => {
            console.log('Notification envoyée avec succès');
            })
            .catch(error => {
            console.error('Erreur lors de l\'envoi de la notification:', error);
            });
        },
      formatThounsends: function(value, fixe = false, number = 0){
        value != null ? value = value :value = 0
        if(fixe){
          value = value.toFixed(number)
        }
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      },
      appendLeadingZeroes(n){
        if(n <= 9){
          return "0" + n;
        }
        return n
      },
      CustomSort_tauxmer_sante(a, b) {
        return sortRateNullLast(a, b, 'taux_mer')
      }
    },
  }
  </script>

<style>

  .booking-table-rows {
    text-transform: uppercase;
  }

  .extract-cell-link {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    min-height: 1em;
  }

  /* Unique to this page card — ListGlobalTable is also used by ExtractMer.vue */
  .stat-gustave-product-perf .product-perf-title {
    font-weight: 700;
    text-transform: none;
    letter-spacing: 0.01em;
    display: flex;
    align-items: center;
  }

  .stat-gustave-product-perf .product-perf-header-right {
    gap: 8px;
  }

  .stat-gustave-product-perf .product-perf-legends {
    margin-left: -8px;
    margin-right: -8px;
  }

  .stat-gustave-product-perf .product-perf-legends > [class*='col-'] {
    padding-left: 12px;
    padding-right: 12px;
  }

  .stat-gustave-product-perf .product-perf-legend-card {
    background: rgba(26, 34, 56, 0.95);
    border: 1px solid rgba(139, 149, 167, 0.28);
    border-radius: 12px;
    padding: 18px 22px 16px;
    height: 100%;
  }

  .stat-gustave-product-perf .product-perf-legend-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    margin-bottom: 18px;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.92);
  }

  .stat-gustave-product-perf .product-perf-legend-title i {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.75);
  }

  .stat-gustave-product-perf .product-perf-legend-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 72px;
    width: 100%;
  }

  .stat-gustave-product-perf .product-perf-legend-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 0;
    font-size: 0.85rem;
    flex: 0 0 auto;
  }

  .stat-gustave-product-perf .product-perf-legend-text {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
  }

  .stat-gustave-product-perf .product-perf-legend-range {
    color: rgba(255, 255, 255, 0.95);
    font-weight: 600;
    font-size: 0.85rem;
    white-space: nowrap;
  }

  .stat-gustave-product-perf .product-perf-legend-label {
    color: rgba(180, 190, 210, 0.9);
    font-size: 0.8rem;
    white-space: nowrap;
  }

  .stat-gustave-product-perf .product-perf-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
    margin-top: 4px;
  }

  .stat-gustave-product-perf .dot-red { background: #ff4d4f; }
  .stat-gustave-product-perf .dot-orange { background: #ff9f1a; }
  .stat-gustave-product-perf .dot-green { background: #57d17c; }
  .stat-gustave-product-perf .dot-blue { background: #4da3ff; }
  .stat-gustave-product-perf .dot-neutral { background: #8b95a7; }

  .stat-gustave-product-perf .el-table__footer .cell {
    line-height: 1.2;
  }

</style>
